import { useEffect, useState } from "react";
import { IContainerHistoryPoint } from "../interfaces/IContainerHistoryPoint";
import { IContainerScanEvent } from "../interfaces/IContainerScanEvent";

export const useContainerHistoryPoints = (
    containerHistoryPoints: IContainerHistoryPoint[],
    scanEvents: IContainerScanEvent[],
    daysBack: number,
    fromDate?: Date | null
) => {
    const [filteredContainerHistoryPoints, setFilteredContainerHistoryPoints] = useState<IContainerHistoryPoint[]>([]);
    const [filteredScanEvents, setFilteredScanEvents] = useState<IContainerScanEvent[]>([]);

    useEffect(() => {
        generateFilteredDates();
    }, [containerHistoryPoints, scanEvents, daysBack, fromDate]);

    const generateFilteredDates = () => {
        let pastDate: Date | null = null;

        if (daysBack !== 0) {
            const today = new Date();
            pastDate = new Date(today);
            pastDate.setDate(today.getDate() - daysBack);
        }

        if (fromDate) {
            pastDate = pastDate && pastDate > fromDate ? pastDate : fromDate;
        }

        const filteredPoints = pastDate
            ? containerHistoryPoints.filter(p => new Date(p.lastActiveDate) > pastDate!)
            : containerHistoryPoints;

        const filteredEvents = pastDate
            ? scanEvents.filter(e => new Date(e.date) > pastDate!)
            : scanEvents;

        setFilteredContainerHistoryPoints(filteredPoints);
        setFilteredScanEvents(filteredEvents);
    };

    return { filteredContainerHistoryPoints, filteredScanEvents };
};
